import React, { Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'

const MarketplaceApp = React.lazy(() => import('./App'))

export function getMarketplaceRoutes(): RouteObject[] {
  return [
    {
      path: '/marketplace',
      element: (
        <Suspense fallback={<div className="p-6">Loading marketplace…</div>}>
          <ErrorBoundary>
            <MarketplaceApp />
          </ErrorBoundary>
        </Suspense>
      ),
    },
  ]
}

class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null }
  static getDerivedStateFromError(error: Error) { return { error } }
  componentDidCatch(error: Error) { console.error('Marketplace route error:', error) }
  render() {
    if (this.state.error) {
      return <div className="p-6 text-destructive">Failed to load marketplace</div>
    }
    return this.props.children
  }
}
